import { LocalStorageKeys } from '@authentication/constants';

const BASE_ROOT = process.env.REACT_APP_BACKEND_URI;

const AUTH = `${BASE_ROOT}/authentication`;

const USERS = `${BASE_ROOT}/users`;

const STORES = `${BASE_ROOT}/stores`;

const CANDIDATE = `${BASE_ROOT}/tests`;
const CVVIDEO = `${BASE_ROOT}/cvvideo`;
class Auth {
  public static base = AUTH;
  public static loginHostess = `${AUTH}/login-cv-video`;
  public static refreshAccessToken = `${AUTH}/refresh-token`;
}

class User {
  public static base = USERS;
  public static getCurrentUser = `${USERS}/me`;
}
class Stores {
  public static base = STORES;
  public static getAll = `${STORES}?page=1&limit=10`;
}
class Candidate {
  public static all = `${CANDIDATE}/`;
  public static storeId = localStorage.getItem(LocalStorageKeys.STORE_ID) ?? 0;

  public static getCandidateByPhone = (phone: string, storeIdM: number) =>
    `${CANDIDATE}/paged?storeId=${storeIdM}&page=1&limit=10&keyword=${phone.replace(
      '+',
      '',
    )}&today=false&startDate=&endDate=&qualifications=&selectedHostessesIds=&isShared=`;
}

class CvVideo {
  public static uploadCvVideo = (candidateId: number) =>
    `${CVVIDEO}/${candidateId}`;
}
export default class EndPoints {
  public static auth = Auth;
  public static user = User;
  public static Stores = Stores;
  public static Candidate = Candidate;
  public static CvVideo = CvVideo;
}
